// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gcldt","footer":"styles_footer__21PIF"};